import TabBar from './tab-bar.vue';
export default TabBar;